/** Held while a lazily-loaded chunk is on the wire. */
export function LoadingBlock({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="p-4" role="status" aria-live="polite">
      <div className="h-40 animate-pulse rounded-lg bg-hilevel-light" />
      <span className="sr-only">{label}</span>
    </div>
  );
}
